module.exports = __webpack_public_path__ + "static/media/samsa - butterflies.791d7fcf.mp3";